module.exports = __webpack_public_path__ + "static/media/claro_thumb_even.d0a32fd7.jpg";